import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/mekanet/node_modules/next/dist/client/app-dir/link.js");
